import $ from "jquery";

export function ScreenWidthIsMobile() {
    const maxMobileScreenWidth = 991;
    let onMobileScreen = true;

    if(window.innerWidth > maxMobileScreenWidth) {
        onMobileScreen = false;
    }

    return onMobileScreen;
}

export function ScrollToPageSection() {
    const button = $('[data-id="button-scroll-to-page-section"]');

    button.click(function() {
        $('html, body').animate({
            scrollTop: $("#menukaart").offset().top
        }, 250);
    })
}

export function scrollToId() {
    $('a[href*="#"]')
    // Remove links that don't actually link to anything
        .not('[href="#"]')
        .not('[href="#0"]')
        .click(function(event) {
            // On-page links
            console.log('test');
            if (
                location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
                &&
                location.hostname == this.hostname
            ) {
                // Figure out element to scroll to
                var target = $(this.hash);
                target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $('html, body').animate({
                        scrollTop: target.offset().top
                    }, 500, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $(target);
                        $target.focus();
                        if ($target.is(":focus")) { // Checking if the target was focused
                            return false;
                        } else {
                            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        };
                    });
                }
            }
        });
}

export function calcViewHeight() {
    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
}